import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    description: Yup.string().required('توضیحات ضروری می باشد'),
})
